<template>
    <div>
        <Table :class="[classes, 'dw-table']" 
                :data="data"
                :columns="columns" 
                stripe 
                border 
                :show-header="showHeader"
                :width="width"
                :height="height"
                :loading="loading"
                :disabled-hover="disabledHover"
                :highlight-row="highlightRow"
                :row-class-name="rowClassName"
                :size="size"
                :no-data-text="noDataText"
                :no-filtered-data-text="noFilteredDataText"
                @on-current-change="onCurrentChange"
                @on-select="onSelect"
                @on-select-cancel="onSelectCancel"
                @on-select-all="onSelectAll"
                @on-selection-change="onSelectionChange"
                @on-sort-change="onSortChange"
                @on-filter-change="onFilterChange"
                @on-row-click="onRowClick"
                @on-row-dblclick="onRowDblclick"
                @on-expand="onExpand"></Table>
    </div>
</template>
<script>
import table from './tableMove.js'
export default {
    data() {
        return {
            classes: ''
        }
    },
    props: {
        data: Array,
        columns: Array,
        stripe: Boolean,
        border: Boolean,
        showHeader: {
            type: Boolean,
            default: true
        },
        width: {
            type: [Number, String]
        },
        height: {
            type: [Number, String]
        },
        loading: Boolean,
        disabledHover: {
            type: Boolean,
            default: false
        },
        highlightRow: {
            type: Boolean,
            default: false
        },
        rowClassName: {
            type: Function
        },
        size: String,
        noDataText: String,
        noFilteredDataText: String
    },
    methods:{
        onCurrentChange(currentRow, oldCurrentRow) {
            this.$emit('on-current-change', currentRow, oldCurrentRow);
        },
        onSelect(selection, row) {
            this.$emit('on-select', selection, row);
        },
        onSelectCancel(selection, row) {
            this.$emit('on-select-cancel', selection, row);
        },
        onSelectAll(selection) {
            this.$emit('on-select-all', selection);
        },
        onSelectionChange(selection) {
            this.$emit('on-selection-change', selection)
        },
        onSortChange(selection) {
            this.$emit('on-sort-change', selection)
        },
        onFilterChange(val) {
            this.$emit('on-filter-change', val)
        },
        onRowClick(val, index) {
            this.$emit('on-row-click', val, index);
        },
        onRowDblclick(val, index) {
            this.$emit('on-row-dblclick', val, index);
        },
        onExpand(row, status) {
            this.$emit('on-expand', row, status);
        },
        /* 生成地图唯一编码 */
        guid () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                return v.toString(16);
            });
        },
    },
    mounted() {
        this.classes = this.guid();
        let arr = this.$store.state.table.tableMove;
        let arrCol = this.$store.state.table.tableCol;
        if(!arr) arr = [];
        if(!arrCol) arrCol = {};
        if(!arr.includes(this.classes)){
            arr.push(this.classes);
            arrCol[this.classes] = this.columns;
        }
        this.$store.commit('updateTableCol', arrCol);
        this.$store.commit('updateTableMove', arr);
        table.init(this);
    }
}
</script>



// WEBPACK FOOTER //
// src/views/main-components/table/table.vue